import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { ChartBar, UsersThree, Database, CreditCard, ArrowSquareOut, SignOut, ShieldCheck, PaperPlaneTilt, ClockCounterClockwise, Buildings, Broadcast, Flag, ChartLineUp, Stack, Target, Globe, Plug, Lightning, Storefront, Bank } from "@phosphor-icons/react";

const NAV = [
  { to: "/admin", end: true, label: "Tableau de bord", icon: ChartBar, testid: "admin-nav-dashboard" },
  { to: "/admin/ai-analytics", label: "Efficacité IA", icon: ChartLineUp, testid: "admin-nav-ai" },
  { to: "/admin/organizations", label: "Organisations", icon: Buildings, testid: "admin-nav-orgs" },
  { to: "/admin/marketplace", label: "Marketplace", icon: Storefront, testid: "admin-nav-marketplace" },
  { to: "/admin/sources", label: "Sources de signaux", icon: Broadcast, testid: "admin-nav-sources" },
  { to: "/admin/decision-roles", label: "Rôles décideurs", icon: Target, testid: "admin-nav-decision-roles" },
  { to: "/admin/review", label: "Revue IA", icon: Flag, testid: "admin-nav-review" },
  { to: "/admin/it-market", label: "IT & Marché France", icon: ShieldCheck, testid: "admin-nav-it-market" },
  { to: "/admin/classification", label: "Qualité classification", icon: ShieldCheck, testid: "admin-nav-classification" },
  { to: "/admin/taxonomy", label: "Référentiel métiers", icon: Stack, testid: "admin-nav-taxonomy" },
  { to: "/admin/users", label: "Utilisateurs", icon: UsersThree, testid: "admin-nav-users" },
  { to: "/admin/content", label: "Contenu marché", icon: Database, testid: "admin-nav-content" },
  { to: "/admin/domains", label: "Enrichissement domaines", icon: Globe, testid: "admin-nav-domains" },
  { to: "/admin/sirene", label: "Référentiel SIRENE", icon: Bank, testid: "admin-nav-sirene" },
  { to: "/admin/integrations", label: "Intégrations API", icon: Plug, testid: "admin-nav-integrations" },
  { to: "/admin/providers", label: "Fournisseurs de données", icon: Lightning, testid: "admin-nav-providers" },
  { to: "/admin/payments", label: "Paiements", icon: CreditCard, testid: "admin-nav-payments" },
  { to: "/admin/emails", label: "Communication", icon: PaperPlaneTilt, testid: "admin-nav-emails" },
  { to: "/admin/activity", label: "Activité", icon: ClockCounterClockwise, testid: "admin-nav-activity" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bg relative z-10 flex">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-border bg-surface min-h-screen flex flex-col fixed">
        <div className="p-5 border-b border-border">
          <Logo size="text-xl" />
          <div className="flex items-center gap-1.5 mt-2 text-accent">
            <ShieldCheck size={13} weight="fill" />
            <span className="overline !text-accent">Administration</span>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm hover-lift ${
                    isActive ? "bg-surface-2 text-fg border border-border" : "text-muted hover:text-fg"
                  }`
                }
              >
                <Icon size={17} />
                {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-border space-y-1">
          <button onClick={() => navigate("/app")} data-testid="switch-to-esn-btn"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-fg bg-surface-2 border border-border hover-lift hover:border-accent/40">
            <ArrowSquareOut size={17} /> Voir l'espace ESN
          </button>
          <button onClick={() => { logout(); navigate("/"); }} data-testid="admin-logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-muted hover:text-fg">
            <SignOut size={17} /> Déconnexion
          </button>
        </div>
      </aside>

      {/* Content */}
      <div className="flex-1 ml-64">
        <header className="glass border-b border-border h-16 flex items-center px-8 sticky top-0 z-30">
          <div className="ml-auto text-right">
            <div className="text-sm text-fg leading-tight">{user?.name}</div>
            <div className="text-xs text-muted leading-tight font-mono">Administrateur</div>
          </div>
        </header>
        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
